
angular.module('Services')
    .factory('Windows', function () {
        return {
            confirm: function(params) {
                var body = angular.element('body:first');
                var mask = angular.element('<div></div>').addClass('windows-mask');
                var notice = angular.element('<div></div>').addClass('windows-notice');

                var detach = function() {
                    mask.detach().remove();
                    notice.detach().remove();
                    body.removeClass('windows-body');
                };

                var confirm = function() {
                    detach();
                    if (params['onConfirm']) {
                        params['onConfirm']();
                    }
                };

                var close = function() {
                    detach();
                    $(window).off('resize', moveToCenter);
                    if (params['onClose']) {
                        params['onClose']();
                    }
                };

                var confirmButton = angular.element(
                    '<button class="btn btn-success btn-quirk window-confirm-btn">' +
                        '<span class="btn-text">' + (params['confirmText'] || 'Confirm') + '</span>' +
                    '</button>'
                ).on('click', confirm);
                var cancelButton = angular.element(
                    '<button class="btn btn-danger btn-quirk window-confirm-btn">' +
                    '<span class="btn-text">' + (params['cancelText'] || 'Cancel') + '</span>' +
                    '</button>'
                ).on('click', close);

                var titleWindow = angular.element('<div>').text(params['title'] || 'Confirm the action').addClass('windows-title');
                var contentContainer = angular.element('<div>').text(params['text'] || 'Confirm the action').addClass('windows-text');

                var contentBlock = angular.element('<div>').append(titleWindow, contentContainer).addClass('windows-content');
                var buttonsBlock = angular.element('<div>').append(confirmButton, cancelButton).addClass('windows-buttons');

                notice.append(contentBlock, buttonsBlock);
                body.append(mask, notice).addClass('windows-body');

                var moveToCenter = function() {
                    notice.css({
                        marginLeft: - notice.outerWidth() / 2,
                        marginTop: - notice.outerHeight() / 2
                    });
                };
                $(window).on('resize', moveToCenter);
                moveToCenter();
                notice.addClass('on-visible');

                var onMaskDown = function() {
                    notice.css({
                        transform: 'scale(1.02)'
                    });
                    setTimeout(function() {
                        notice.css({
                            transform: ''
                        });
                    }, 150);
                };

                mask.on('mousedown', onMaskDown);
            },
        };
    });





// WEBPACK FOOTER //
// ./js/services/windows.js